import React from 'react';

import { useTranslation } from '@lt/localization';
import { Button } from '@lt/components';

import ReviewsItem from 'src/components/Reviews/ReviewsItem';
import LinkButton from '../../../LinkButton';

import {
  REVEIW_MAX_HEIGHT,
  REVEIW_MAX_CONTENT_LENGTH,
  REVEIW_MAX_HEIGHT_MOBILE,
  REVEIW_MAX_CONTENT_LENGTH_MOBILE,
} from '../../../../constants';

import type { PropsFromRedux as IReviewsLevelTravel } from '.';

import styles from './reviewsLevelTravel.module.css';

export const ReviewsLevelTravel = ({
  items,
  showMore,
  isShowMoreVisible,
  isMobile,
  isWhitelabel,
  hotelReviewsLink,
}: IReviewsLevelTravel): JSX.Element => {
  const { t } = useTranslation();

  return items && items.length > 0 ? (
    <>
      {items.map(({ created_at, ...item }) => (
        <ReviewsItem
          {...item}
          created_at={created_at}
          key={created_at}
          maxContainerHeight={
            isMobile ? REVEIW_MAX_HEIGHT_MOBILE : REVEIW_MAX_HEIGHT
          }
          maxContentLength={
            isMobile
              ? REVEIW_MAX_CONTENT_LENGTH_MOBILE
              : REVEIW_MAX_CONTENT_LENGTH
          }
          showDate
        />
      ))}
      {isWhitelabel && isShowMoreVisible && (
        <div className={styles.showMoreContainer}>
          <Button
            className={styles.showMoreLinkButton}
            onClick={showMore}
            size="flex"
          >
            {t('hotel.reviews.moreReviews')}
          </Button>
        </div>
      )}
      {!isWhitelabel && isShowMoreVisible && (
        <div>
          <LinkButton href={hotelReviewsLink}>
            {t('hotel.reviews.allReviews')}
          </LinkButton>
        </div>
      )}
    </>
  ) : (
    <div>{t('hotel.reviews.emptyTitleLT')}</div>
  );
};
